import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Clapperboard } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(match[1]);
    api.post("/auth/google/session", { session_id })
      .then(({ data }) => {
        setSession(data);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || "Google sign-in failed. Please try again.";
        window.history.replaceState(null, "", "/login");
        navigate(`/login?msg=${encodeURIComponent(msg)}`, { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 bg-[#050505]">
      <div className="flex h-11 w-11 items-center justify-center rounded-md bg-[#00E5FF] text-black">
        <Clapperboard className="h-6 w-6" />
      </div>
      <div className="flex items-center gap-2 text-sm text-gray-400">
        <Loader2 className="h-4 w-4 animate-spin text-[#00E5FF]" /> Signing you in with Google…
      </div>
    </div>
  );
}
